import axios from 'axios'
import { getToken } from '../store/auth'
export const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
  // baseURL: 'http://10.10.10.33:3002/'
})

http.interceptors.request.use(config => {
  // Do something before request is sent
  let token = getToken()
  if (token) {
    config.headers['x-access-token'] = token // cada solicitação carrega o token - ['Authorization'] como a chave personalizada. Modifique-o de acordo com a situação real.
  }
  return config
}, error => {
  // Do something with request error
  console.log('request', error) // for debug
  Promise.reject(error)
})
